module.exports = __webpack_public_path__ + "static/media/cancel_icon.edda7a24.svg";